<template>
  <div class="lg:pt-4 md:pt-4">
    <div class="gridbg"></div>
    <div class="relative lg:px-0 md:px-0 px-4">
      <div class="absolute bg-design13 mob-hidden">
        <img
          src="../../../assets/images/dots.svg"
          alt="bg-polygon"
          class="h6rem opacity07"
        />
      </div>
      <div class="absolute bg-design14 mob-hidden">
        <img
          src="../../../assets/images/dots.svg"
          alt="bg-polygon"
          class="h6rem opacity07"
        />
      </div>
      <div class="lg:w-4/5 md:w-4/5 latest-88per sm-full mx-auto m-33rem">
        <p
          class="title sm-fsize16 md:font-normal lg:font-normal font-bold lg:pb-8 md:pb-8 pb-4 pl-2"
        >
          Latest
        </p>
        <div class="w-full ht660px lg:flex md:flex">
          <div class="w30perc sm-full">
            <div
              class="flex h-1/2 w-full sm-h190px latestimgtitle showhim lg:mb-0 md:mb-0 mb-2 cursor-pointer"
              @click="handleClick('news')"
            >
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/news-3.jpg"
                class="w-full h-full object-cover rounded1-37rem lg:p-2 md:p-2 blackwhite"
                alt="cancer Child"
              />
              <div class="latestimgtitle-content_top showme pr-8">
                <div class="flex items-center">
                  <img
                    src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/2023-09-27T12:20:47.991Z/fileicon.11c3457d.svg"
                    alt=""
                    class="h-8 w-8 blackwhite object-contain"
                  />
                  <span
                    class="md:pl-5 lg:pl-5 pl-3 font-bold md:text-xl lg:text-xl tracking-widest"
                    >News</span
                  >
                </div>
                <!-- <div
                class="
                  pt-4
                  pb-1
                  ellipsis-4
                  clr777-white
                  fsize18px
                  sm-fsize12
                  font-semibold
                  mob-hidden
                "
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </div> -->
              </div>
            </div>
            <div
              class="flex h-1/2 w-full sm-h190px latestimgtitle showhim lg:mb-0 md:mb-0 mb-2 cursor-pointer"
              @click="handleClick('regulation-policies-papers')"
            >
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi-new/image/Caregiver%20Diaries.jfif"
                class="w-full h-full object-cover rounded1-37rem lg:p-2 md:p-2 blackwhite"
                alt="cancer Child"
              />
              <div class="latestimgtitle-content_top showme pr-8">
                <div class="flex items-center">
                  <img
                    src="../../../assets/images/business.png"
                    alt=""
                    class="h-8 w-8 blackwhite object-contain"
                  />
                  <span
                    class="md:pl-5 lg:pl-5 pl-3 font-bold md:text-xl lg:text-xl tracking-widest"
                    >Regulations,Policies & Paper</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="lg:flex md:flex flex-wrap w70perc h-1/2 sm-full">
            <div
              class="w42perc sm-full lg:mb-0 md:mb-0 mb-2 sm-h190px h-full latestimgtitle showhim showhim"
              @click="handleClick('events')"
            >
              <img
                src="../../../assets/images/LatestSeg/Event.png"
                class="w-full h-full object-cover rounded1-37rem lg:p-2 md:p-2 blackwhite cursor-pointer"
                alt="New Born"
              />
              <div class="latestimgtitle-content showme animated bounce">
                <div class="flex items-center">
                  <img
                    src="../../../assets/images/calendar.svg"
                    alt=""
                    class="md:h-10 lg:h-10 h-5 lg:w-10 md:w-10"
                  />
                  <span
                    class="md:pl-5 lg:pl-5 pl-3 font-bold text-sm md:text-xl lg:text-xl tracking-widest clr777-white"
                    >Event</span
                  >
                </div>
              </div>
            </div>
            <div
              class="w58perc lg:mb-0 md:mb-0 mb-2 sm-full sm-h190px h-full latestimgtitle showhim"
              @click="handleClick('insights-blogs')"
            >
              <img
                src="../../../assets/images/LatestSeg/Blog1.png"
                class="w-full h-full object-cover rounded1-37rem lg:p-2 md:p-2 blackwhite cursor-pointer"
                alt="New Born"
              />
              <div class="latestimgtitle-content showme">
                <div class="flex items-center">
                  <img
                    src="../../../assets/images/ph_article.svg"
                    alt=""
                    class="md:h-10 lg:h-10 h-5 lg:w-10 md:w-10"
                  />
                  <span
                    class="md:pl-5 lg:pl-5 pl-3 font-bold text-sm md:text-xl lg:text-xl tracking-widest"
                    >Blogs</span
                  >
                </div>
              </div>
            </div>

            <div
              class="lg:w-2/3 lg:mb-0 md:mb-0 mb-2 md:w-2/3 sm-full sm-h190px h-full latestimgtitle showhim"
              @click="handleClick('podcast')"
            >
              <img
                src="../../../assets/images/LatestSeg/podcast 2.png"
                class="w-full h-full object-cover rounded1-37rem lg:p-2 md:p-2 blackwhite cursor-pointer"
                alt="New Born"
              />
              <div class="latestimgtitle-content showme">
                <div class="flex items-center">
                  <img
                    src="../../../assets/images/la_podcast.svg"
                    alt=""
                    class="md:h-10 lg:h-10 h-5 lg:w-10 md:w-10"
                  />
                  <span
                    class="md:pl-5 lg:pl-5 pl-3 font-bold text-sm md:text-xl lg:text-xl tracking-widest"
                    >Podcast</span
                  >
                </div>
              </div>
            </div>
            <div
              class="lg:w-1/3 lg:mb-0 md:mb-0 mb-2 md:w-1/3 sm-full sm-h190px h-full latestimgtitle showhim"
              @click="handleClick('toolsandhandbook')"
            >
              <img
                src="../../../assets/images/LatestSeg/self help.png"
                class="w-full h-full object-cover rounded1-37rem lg:p-2 md:p-2 blackwhite cursor-pointer"
                alt="New Born"
              />
              <div class="latestimgtitle-content showme">
                <div class="flex items-center">
                  <img
                    src="../../../assets/images/ph_presentation.svg"
                    alt=""
                    class="md:h-10 lg:h-10 h-5 lg:w-10 md:w-10"
                  />
                  <span
                    class="md:pl-5 lg:pl-5 pl-3 font-bold text-sm md:text-xl lg:text-xl tracking-widest"
                    >ToolKits / Downloads</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
